import React, { useEffect, useState } from "react";
import TextField from "@material-ui/core/TextField";
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import { GetLicenseName, GetPatientContactInfo, SearchPatient } from "../appointments/create/api/index";
import {
  Grid,
  Button,
  makeStyles,
  createMuiTheme,
  ThemeProvider,
  Dialog,
  DialogContent,
  Typography,
  NativeSelect,
  DialogActions,
  DialogTitle,
  IconButton
} from "@material-ui/core";
import { useForm } from "react-hook-form";
import useStyle from "../appointments/create/css/styles";
import { format } from "date-fns";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import OTPModal from "../appointments/create/components/OTPModal";
import { useHistory } from "react-router";
import CloseIcon from "@material-ui/icons/Close";


//Update log
// FB 4867 DK   12/27/2021    Added screens for Support files and Health forms upload
// FB 10675 DK  06/10/2025    Landing page not working properly; Please identify yourself page should display before buttons
//


export default function Verfication(props: any) {
  const [FirstName, setFirstName] = useState("");
  const [LastName, setLastName] = useState("");
  const [DOB, setDOB] = useState<any>(null);
  const [Gender, setGender] = useState(0);
  const [firstNameError, setfirstNameError] = useState(false);
  const [firstNameMessage, setfirstNameMessage] = useState("");
  const [lastNameError, setlastNameError] = useState(false);
  const [lastNameMessage, setlastNameMessage] = useState("");
  const [dateforDOBfield, setDateforDOBfield] = useState<any>(null);
  const [DOBError, setDOBError] = useState(false);
  const [DOBMessage, setDOBMessage] = useState("");
  const [GenderError, setGenderError] = useState(false);
  const [genderMessage, setGenderMessage] = useState("");
  const [displayVerfiedMessage, SetdisplayVerfiedMessage] = useState("none");
  const [resultMessage, setResultMessage] = useState("");
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [patientContact, setPatientContact] = useState({ email: "", cellPhone: "" });
  const [validationObj, setValidationObj] = useState({
    firstNameError: false,
    firstNameMessage: "",
    lastNameError: false,
    lastNameMessage: "",
    DOBError: false,
    DOBMessage: ""
  });
  var decodedAppt_n = Buffer.from(props.match.params.apptId, "base64").toString();

  const handleFirstNameChange = (event: any) => {
    setFirstName(event.target.value);
    const re = /^(?=.{1,40}$)[a-zA-Z0-9 ]+(?:[-'\s][a-zA-Z0-9 ]+)*$/;
    if (event.target.value === "" && re.test(event.target.value)) {
      setFirstName(event.target.value);

      setValidationObj({
        ...validationObj,
        firstNameError: true,
        firstNameMessage: "Enter valid first name",
      });

      setfirstNameError(true);
      setfirstNameMessage("Enter valid first name");
    }
    if (event.target.value != "") {
      setValidationObj({
        ...validationObj,
        firstNameError: false,
        firstNameMessage: "",
      });

      setfirstNameError(false);
      setfirstNameMessage("");
    }
  };

  //FB 4371 BR    03/29/2021    validation for patient last name
  const handleLastNameChange = (event: any) => {
    setLastName(event.target.value);
    const re = /^(?=.{1,40}$)[a-zA-Z0-9 ]+(?:[-'\s][a-zA-Z0-9 ]+)*$/;
    if (event.target.value === "" && re.test(event.target.value)) {
      setLastName(event.target.value);

      setValidationObj({
        ...validationObj,
        lastNameError: true,
        lastNameMessage: "Enter valid last name",
      });

      setlastNameError(true);
      setlastNameMessage("Enter valid last name");
    }
    if (event.target.value != "") {
      setValidationObj({
        ...validationObj,
        lastNameError: false,
        lastNameMessage: "",
      });

      setlastNameError(false);
      setlastNameMessage("");
    }
  };

  const handleDOBChange = (date: any) => {
    if (date != null && date != "Invalid Date") {
      setDateforDOBfield(date);		//FB 4499 DK - Save the selected date
      setDOB(format(date, "yyyy-MM-dd"));
      if (
        format(date, "yyyy-MM-dd") < "1800-01-01" &&
        format(date, "yyyy-MM-dd") > "9999-01-01"
      ) {
        alert(format(date, "yyyy-MM-dd"));
      }
      if (date == null) {
        setDOBError(true);
        setDOBMessage("Enter valid Date of Birth");
      }
      if (date != null) {
        setDOBError(false);
        setDOBMessage("");
      }
    }
    else {
      if (date == "Invalid Date") {
        setDOBError(true);
        setDOBMessage("Enter valid Date of Birth");
      }
    }
  };

  const handleGenderChange = (event: React.ChangeEvent<{ value: any }>) => {
    setGender(parseInt(event.target.value));
    if (event.target.value === "") {
      setGenderError(true);
      setGenderMessage("Select the State");
    } else {
      setGenderError(false);
      setGenderMessage("");
    }
  };

  const styles = useStyle();

  const useStyles = makeStyles({
    active: {
      backgroundColor: "#18a2b8",
      color: "white",
      textTransform: "capitalize",
      borderRadius: "15px",
      marginLeft: "20px",
      "&:hover": {
        backgroundColor: "#18a2b8",
      },
    },
    buttonactive: {
      backgroundColor: "#18a2b8",
      color: "white",
      textTransform: "capitalize",
      borderRadius: "15px",
      "&:hover": {
        backgroundColor: "#18a2b8",
      },
      width: "160px",
    },
    inactive: {
      backgroundColor: "white",
      color: "#18a2b8",
      textTransform: "capitalize",
      borderRadius: "15px",
    },
    buttonMargin: {
      marginLeft: "100px",
    },
    datepickerroot: {
      "&.MuiIconButton-root": {
        color: "#18a2b8",
      },
    },
    dropdown_nomargin: {
      "&.MuiFormControl-marginNormal": {
        color: "#18a2b8",
      },
      //FB 4574 DK - Added styling for dropdown icon
      "& .MuiSvgIcon-root": {
        fontSize: "2rem"
      }
    },
    //FB 4574 DK - Added a new class for calender icon
    iconCSS: {
      "& .MuiSvgIcon-root": {
        fontSize: "1.8rem"
      },
      "& .MuiIconButton-root": {
        color: "#18a2b8",
      },
    }
  });

  const theme = createMuiTheme({
    palette: {
      primary: {
        main: "#18a2b8",
      },
    },
  });

  const classes = useStyles();

  const { register, handleSubmit, errors } = useForm();


  const patientObj = {
    PATIENT_FIRST_NAME: FirstName,
    PATIENT_LAST_NAME: LastName,
    PATIENT_BIRTH_DAY: DOB,
    GENDER_N: Gender,
  }

  const buttonclick = async () => {
    const reName = /^(?=.{1,40}$)[a-zA-Z0-9 ]+(?:[-'\s][a-zA-Z0-9 ]+)*$/;
    if (!reName.test(FirstName)) {
      setValidationObj({
        ...validationObj,
        firstNameError: true,
        firstNameMessage: "Enter valid first name",
      });
      setfirstNameError(true);
      setfirstNameMessage("Enter valid first name");
    }
    if (!reName.test(LastName)) {
      setValidationObj({
        ...validationObj,
        lastNameError: true,
        lastNameMessage: "Enter valid last name",
      });
      setlastNameError(true);
      setlastNameMessage("Enter valid last name");
    }
    //FB 4371: Bindu:Start - Bug fix for the DOB
    if (DOB == null) {
      setDOBError(true);
      setDOBMessage("Enter valid Date of Birth");
    }
    var reGoodDate = /^\d{4}\-(0?[1-9]|1[012])\-(0?[1-9]|[12][0-9]|3[01])$/;
    if (!reGoodDate.test(DOB)) {
      setDOBError(true);
      setDOBMessage("Enter valid Date of Birth");
    }
    //FB 4371: Bindu:End - Bug fix for the issue for DOB

    if (
      FirstName.length != 0 &&
      LastName.length != 0 &&
      //FB 4371: Bindu - Bug fix for the issue for DOB
      DOB != null &&
      Gender != 0
    ) {

      const data = await SearchPatient(patientObj).then(async (data) => {
        if (data.length == 0 || data[0] == undefined) {
          SetdisplayVerfiedMessage("flex");
          setResultMessage("Patient record not found")
        } else {
          SetdisplayVerfiedMessage("flex");
          setResultMessage("");
          setPatientContact({ email: data[0].PATIENT_EMAIL, cellPhone: data[0].PATIENT_CELL_PHONE });
          setOpenDialog(true);
        }
      }).catch((error) => error);

    } else {
      if (Gender == 0) {
        setGenderError(true);
        setGenderMessage("Select the gender");
      }
    }
  };

  const history = useHistory();
  useEffect(() => {
    async function redirect() {
      var IsPatientVerified = sessionStorage.getItem("IsPatientVerified");
      if (IsPatientVerified === "Yes") {
        let licensename = await GetLicenseName();
        licensename = licensename[0].replace(' ', '+');
        history.push("/appointments/landingPage/" + props.match.params.apptId + "/" + licensename + "/1");
      }
    }
    redirect();
  }, [openDialog]);

  const scrollTo = (ref: any) => {
    if (ref /* + other conditions */) {
      ref.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  useEffect(() => {
    setResultMessage("");
  }, [FirstName, LastName, DOB, Gender])

  return (
    <div>
      <section
        ref={scrollTo}
        style={{
          margin: "10px 20px 20px",
        }}
      >
        <Grid container direction="column" justify="center" alignItems="center" style={{ marginTop: "2%" }}>
          <Grid item xs={12}>
            <Typography style={{ fontWeight: "bold" }} variant="h5">
              Please identify yourself
            </Typography>
          </Grid>
        </Grid>
        <Grid container>
          <Grid
            lg={12}
            md={12}
            sm={12}
            xs={12}
            style={{
              display: displayVerfiedMessage,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography
              id="verifiedMessage"
              variant="h6"
              style={{ color: "red" }}
            >
              {resultMessage}
            </Typography>
          </Grid>
          <br />
        </Grid>
        <Grid container spacing={1}>
          <Grid
            item
            lg={6}
            md={6}
            sm={12}
            xs={12}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <TextField
              name="firstName"
              id="firstName"
              onChange={(e) => handleFirstNameChange(e)}
              style={{ fontSize: "6px", width: 250 }}
              label="First Name *"
              inputRef={register({
                required: true,
                pattern: /^[A-Za-z0-9 ]+$/i,
              })}
              autoCapitalize="none"
              helperText={firstNameMessage}
              error={firstNameError}
            />
          </Grid>
          <Grid
            item
            lg={6}
            md={6}
            sm={12}
            xs={12}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <TextField
              name="lastName"
              id="lastName"
              onChange={(e) => handleLastNameChange(e)}
              style={{ fontSize: "6px", width: 250 }}
              inputRef={register({
                required: true,
                pattern: /^[A-Za-z0-9]+$/i,
              })}
              autoCapitalize="none"
              helperText={lastNameMessage}
              error={lastNameError}
              label="Last Name *"
            />
          </Grid>
        </Grid>
        <Grid container spacing={1}>
          <Grid
            item
            xs={12}
            md={6}
            sm={12}
            lg={6}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {/* FB 4371 : Bindu:Start - Below date control has been changed for the dat of birth field*/}
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <ThemeProvider theme={theme}>
                <KeyboardDatePicker
                  id="dob"
                  inputVariant="standard"
                  orientation="portrait"
                  label="Date of Birth *"
                  style={{ width: 250 }}    //FB 4574 DK - Added width
                  value={dateforDOBfield}		//FB 4499 DK - Changed the variable which contain unformatted date to avoid format failures
                  onChange={(date) => handleDOBChange(date)}
                  format="MM/dd/yyyy"
                  maxDate={new Date()}
                  initialFocusedDate={null}
                  helperText={DOBMessage}
                  error={DOBError}   //FB 4409 DK - Added to disable the DOB field after existing patient verified
                  className={classes.iconCSS} //FB 4574 DK - Added styling for icon
                />
              </ThemeProvider>
            </MuiPickersUtilsProvider>
            {/* FB 4371 : Bindu:End - Below date control has been changed for the dat of birth field*/}
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            sm={12}
            lg={6}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <ThemeProvider theme={theme}>
              <FormControl error={GenderError}>
                <InputLabel shrink>Gender *</InputLabel>
                <NativeSelect
                  className={classes.dropdown_nomargin}
                  style={{ width: 250 }}    //FB 4574 DK - Removed px from width
                  name="gender"
                  id="gender"
                  value={Gender}
                  onChange={handleGenderChange}
                  error={GenderError}
                >
                  <option value={0}></option>
                  <option value={1}>Male</option>
                  <option value={2}>Female</option>
                  <option value={3}>Unknown</option>		//FB 4567 DK - Modified gender option from 'Other' to 'Unknown'
                </NativeSelect>
                <FormHelperText>{genderMessage}</FormHelperText>
              </FormControl>
            </ThemeProvider>
          </Grid>
        </Grid>
        <br />
        <Grid
          container
          spacing={2}
          className={styles.flexend_Grid}
        >
          {/* FB 10675 */}
          <Button
            onClick={buttonclick}
            variant="contained"
            className={styles.navigationButton}
            type="submit"
            id="verify"
          >
            Submit
          </Button>
        </Grid>

        <Dialog open={openDialog} disableBackdropClick fullWidth maxWidth={"xs"}>
          <DialogTitle style={{ display: "flex", alignContent: "center", justifyContent: "center" }}>
            <Typography style={{ fontWeight: "bold" }}>
              Verification
            </Typography>
            <IconButton
              aria-label="close"
              onClick={() => setOpenDialog(false)}
              style={{
                position: 'absolute',
                right: 8,
                top: 8,
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent style={{ display: "flex", alignContent: "center", justifyContent: "center" }}>
            <OTPModal
              onCallback={setOpenDialog}
              patientContact={patientContact}
              appointment_n={decodedAppt_n}
              selectedStep={props.history.location.state?.selectedStep}
            />
          </DialogContent>
          <DialogActions></DialogActions>
        </Dialog>
      </section>
    </div>
  )
}